/*
 * <biobio-antes-depois>: comparador antes/depois da PDP-mestre.
 *
 * Contrato de markup gerado por snippets/biobio-pdp-antes-depois.liquid.
 * Le os pares de um <script type="application/json" data-ad-pares> inline
 * (so URLs, nao binario), entao trocar de tom nao faz roundtrip.
 *
 * Seletor PROPRIO (regua). Por padrao NAO escuta a oferta: ver o comentario no
 * connectedCallback. Com data-ad-segue-oferta (setting seguir_oferta do block,
 * so nas PDPs v2) segue a 1a UNIDADE da oferta pelos eventos
 * 'pdp-offer:variant-changed' e 'pdp-offer:tier-changed' (detail.selected) e,
 * ao conectar, alcanca o estado atual da oferta (snapshotSelected()).
 * API publica: aplicarVariante(variantId) -> boolean.
 *
 * Decisoes que vieram de bugs reais da referencia (Ollie) e do proprio tema:
 * - posicao SO em % (a Ollie mistura px com % e descola no resize);
 * - setPointerCapture + pointercancel (sem eles, no iOS um gesto do sistema
 *   deixa o pointermove grudado no document);
 * - guard de registro no topo: o Shopify NAO dedupa <script> por URL.
 */
(function () {
  if (window.customElements && customElements.get('biobio-antes-depois')) return;

  var REPOUSO_PADRAO = 90;

  function limita(v, min, max) { return Math.max(min, Math.min(max, v)); }

  class BiobioAntesDepois extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this.palco = this.querySelector('.pdp-ad');
      this.handle = this.querySelector('.pdp-ad__handle');
      this.imgA = this.querySelector('[data-ad-antes]');
      this.imgD = this.querySelector('[data-ad-depois]');
      this.capE = this.querySelector('.pdp-ad__cap--esq');
      this.capD = this.querySelector('.pdp-ad__cap--dir');
      if (!this.palco || !this.handle || !this.imgA || !this.imgD) return;

      this.pares = this.lerPares();
      this.pos = REPOUSO_PADRAO;
      this.arrastando = false;
      this._abort = new AbortController();
      var sig = this._abort.signal;

      // Par inicial: o do SSR, que e sempre o PRIMEIRO valido. Por padrao este
      // componente NAO segue a oferta. Motivo, aprendido em producao: no tier
      // "Leve 3" a oferta tem um grupo de swatch por unidade, entao escolher o
      // tom da 2a unidade mudava a foto aqui, o que e errado semanticamente. E
      // como o bloco fica ~2200px abaixo da oferta, a troca acontecia fora da
      // tela. A sincronia opt-in (data-ad-segue-oferta, abaixo) segue so a 1a
      // unidade, o que tira a ambiguidade.
      this.regua = this.querySelector('.pdp-ad-regua');
      this.celulas = this.regua ? Array.prototype.slice.call(this.regua.querySelectorAll('[data-ad-tom]')) : [];
      this.tomNomeEl = this.querySelector('[data-ad-tom-nome]');
      this.aplicarPar(this.parDe(Number(this.dataset.adVariante || 0)) || this.pares[0]);

      if (window.IntersectionObserver) {
        this._io = new IntersectionObserver(function (entradas) {
          if (entradas.some(function (e) { return e.isIntersecting; })) {
            this.prefetch();
            this._io.disconnect();
          }
        }.bind(this), { rootMargin: '400px' });
        this._io.observe(this);
      } else {
        this.prefetch();
      }

      this.handle.addEventListener('pointerdown', this.aoPegar.bind(this), { signal: sig });
      this.handle.addEventListener('pointermove', this.aoMover.bind(this), { signal: sig });
      this.handle.addEventListener('pointerup', this.aoSoltar.bind(this), { signal: sig });
      this.handle.addEventListener('pointercancel', this.aoSoltar.bind(this), { signal: sig });
      this.handle.addEventListener('lostpointercapture', function () { this.arrastando = false; }.bind(this), { signal: sig });
      this.handle.addEventListener('keydown', this.aoTeclar.bind(this), { signal: sig });
      // `click`, NAO `pointerdown`: no mobile a figura tem ~500px de altura e e
      // o alvo natural pra rolar a pagina. Reposicionar no pointerdown fazia
      // qualquer rolagem iniciada sobre a foto arrastar a alca junto (medido:
      // scrollY 314 e a alca pulando de 90 pra 8,7). O `click` so dispara quando
      // nao houve gesto de rolagem.
      this.palco.addEventListener('click', this.aoClicarPalco.bind(this), { signal: sig });

      if (this.regua) {
        this.regua.addEventListener('click', this.aoClicarRegua.bind(this), { signal: sig });
        this.regua.addEventListener('keydown', this.aoTeclarRegua.bind(this), { signal: sig });
      }

      // Sincronia com a oferta: SO com o atributo (setting seguir_oferta, PDPs
      // v2). Sem ele, nas PDPs do pdp-master, nada e escutado. No document, com o
      // mesmo signal: o disconnect tira os ouvintes junto com os outros.
      if (this.hasAttribute('data-ad-segue-oferta')) {
        var aoMudarOferta = this.aoMudarOferta.bind(this);
        document.addEventListener('pdp-offer:variant-changed', aoMudarOferta, { signal: sig });
        document.addEventListener('pdp-offer:tier-changed', aoMudarOferta, { signal: sig });
        this.alcancarOferta();
      }

      this._pronto = true;
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      if (this._io) this._io.disconnect();
      this._pronto = false;
    }

    lerPares() {
      var tag = this.querySelector('script[type="application/json"][data-ad-pares]');
      if (!tag) return [];
      try { return JSON.parse(tag.textContent) || []; } catch (e) { return []; }
    }

    parDe(variantId) {
      var id = Number(variantId);
      for (var i = 0; i < this.pares.length; i++) {
        if (Number(this.pares[i].v) === id) return this.pares[i];
      }
      return null;
    }

    // Marca a celula da regua correspondente ao par em tela e atualiza o nome
    // do tom. Um so `tabindex=0` no grupo, que e o padrao de radiogroup.
    marcarRegua(variantId) {
      if (!this.celulas.length) return;
      var alvo = null;
      this.celulas.forEach(function (c) {
        var ativo = Number(c.dataset.adTom) === Number(variantId);
        if (ativo) alvo = c;
        c.classList.toggle('is-ativo', ativo);
        c.setAttribute('aria-checked', ativo ? 'true' : 'false');
        c.tabIndex = ativo ? 0 : -1;
      });
      if (this.tomNomeEl && alvo) {
        var lbl = alvo.getAttribute('aria-label') || '';
        this.tomNomeEl.textContent = lbl.replace(/^Ver (o tom|a cor)\s*/, '');
      }
    }

    // Troca src+srcset so quando a imagem nova ja decodificou. Marca o host
    // enquanto carrega, pro CSS poder dar um sinal de espera.
    troca(img, src, srcset) {
      if (!img || !src || img.getAttribute('src') === src) return;
      var host = this;
      var pre = new Image();
      if (srcset) pre.srcset = srcset;
      pre.sizes = img.sizes || '';
      pre.src = src;
      host.setAttribute('data-ad-carregando', '');
      var pintar = function () {
        img.setAttribute('srcset', srcset || '');
        img.src = src;
        host.removeAttribute('data-ad-carregando');
      };
      if (pre.decode) {
        pre.decode().then(pintar).catch(pintar);
      } else if (pre.complete) {
        pintar();
      } else {
        pre.onload = pintar;
        pre.onerror = pintar;
      }
    }

    // Baixa os outros pares em ociosidade, uma vez so, depois que o bloco entra
    // na tela. Sem isso o primeiro clique em cada tom espera a rede inteira.
    // 16 imagens no tamanho que o mobile escolhe (560w) dao ~1,2 MB no total, e
    // por isso NAO se faz no load da pagina: so quando o bloco fica visivel.
    prefetch() {
      if (this._prefetched) return;
      this._prefetched = true;
      var pares = this.pares.slice();
      var i = 0;
      var passo = function () {
        if (i >= pares.length) return;
        var par = pares[i++];
        [[par.a, par.as], [par.d, par.ds]].forEach(function (u) {
          if (!u[0]) return;
          var im = new Image();
          if (u[1]) im.srcset = u[1];
          im.sizes = '(min-width: 768px) 460px, 92vw';
          im.src = u[0];
        });
        agendar(passo);
      };
      var agendar = window.requestIdleCallback
        ? function (fn) { window.requestIdleCallback(fn, { timeout: 1200 }); }
        : function (fn) { setTimeout(fn, 220); };
      agendar(passo);
    }

    // detail.selected da oferta: { direct, qty } na compra direta ou
    // { tier, units: [id|null, ...] } nos degraus. Segue a 1a unidade, e so
    // quando ELA muda: trocar o tom da 2a unidade ou a quantidade repete o
    // units[0], e reagir a isso desfaria o tom que a pessoa escolheu na propria
    // regua e levaria a alca de volta ao repouso. Um degrau cuja 1a unidade ainda
    // nao tem tom nao muda nada; voltar a um degrau com outro tom na 1a unidade
    // muda (A no degrau 1, B no 2, volta ao 1: A). Tom ja em tela nao reaplica.
    // Id sem par no JSON (tom oculto, de outro produto) e ignorado pelo
    // aplicarVariante. Payload ruim, ou evento antes do setup, nunca lanca.
    aoMudarOferta(e) {
      var sel = e && e.detail && e.detail.selected;
      if (!sel || typeof sel !== 'object' || !this.pares || !this.pares.length) return;
      var id = (Array.isArray(sel.units) && sel.units[0]) || sel.direct;
      if (id === null || id === undefined || id === '') return;
      if (String(id) === this._tomDaOferta) return;
      this._tomDaOferta = String(id);
      if (String(id) === String(this.dataset.adVariante)) return;
      this.aplicarVariante(Number(id));
    }

    // Os eventos so contam o que muda DEPOIS dos ouvintes. Um tom escolhido na
    // oferta antes de o bloco conectar (o bloco fica bem abaixo dela e o script
    // pode chegar depois) ficaria de fora: aqui o estado atual da oferta entra
    // como se fosse um evento, pela mesma regra do aoMudarOferta (null ou id
    // sem par nao muda nada). Oferta ausente, ainda nao definida (sem
    // snapshotSelected) ou sem setup (snapshot que lanca) nao muda nada: os
    // eventos seguintes alcancam.
    alcancarOferta() {
      try {
        var oferta = document.querySelector('pdp-offer');
        if (!oferta || typeof oferta.snapshotSelected !== 'function') return;
        this.aoMudarOferta({ detail: { selected: oferta.snapshotSelected() } });
      } catch (e) { /* oferta ainda sem setup: os eventos alcancam */ }
    }

    aoClicarRegua(e) {
      var cel = e.target.closest ? e.target.closest('[data-ad-tom]') : null;
      if (!cel) return;
      this.aplicarVariante(Number(cel.dataset.adTom));
    }

    // Setinha anda entre os tons, Home/End vao aos extremos. Padrao WAI-ARIA de
    // radiogroup: mover o foco JA seleciona.
    aoTeclarRegua(e) {
      if (!this.celulas.length) return;
      var i = this.celulas.indexOf(document.activeElement);
      if (i < 0) return;
      var k = e.key, novo = -1;
      if (k === 'ArrowRight' || k === 'ArrowDown') novo = (i + 1) % this.celulas.length;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') novo = (i - 1 + this.celulas.length) % this.celulas.length;
      else if (k === 'Home') novo = 0;
      else if (k === 'End') novo = this.celulas.length - 1;
      else return;
      e.preventDefault();
      this.aplicarVariante(Number(this.celulas[novo].dataset.adTom));
      this.celulas[novo].focus();
    }

    aplicarPar(par) {
      if (!par) return false;
      // srcset JUNTO com src: trocar so o src deixaria o srcset antigo vencendo
      // a escolha do navegador e a foto nao mudaria.
      //
      // `troca()` so pinta depois de decodificar. Sem isso o navegador mantem a
      // foto anterior ate a nova ficar pronta e a troca parece travada, que foi
      // exatamente a queixa em celular real.
      this.troca(this.imgA, par.a, par.as);
      this.troca(this.imgD, par.d, par.ds);
      // number_decimal volta como string ("1.0") do Admin API e do Liquid
      this.palco.style.setProperty('--dz', String(parseFloat(par.dz) || 1));
      this.palco.style.setProperty('--dx', String(parseInt(par.dx, 10) || 0));
      this.palco.style.setProperty('--dy', String(parseInt(par.dy, 10) || 0));
      if (this.capE && par.re) this.capE.textContent = par.re;
      if (this.capD && par.rd) this.capD.textContent = par.rd;
      this.dataset.adVariante = String(par.v);
      this.marcarRegua(par.v);
      var repouso = parseInt(par.pos, 10);
      this.definirPos(isNaN(repouso) ? REPOUSO_PADRAO : repouso);
      return true;
    }

    aplicarVariante(variantId) {
      var par = this.parDe(variantId);
      if (!par) return false;
      return this.aplicarPar(par);
    }

    definirPos(v) {
      this.pos = limita(Number(v) || 0, 0, 100);
      this.palco.style.setProperty('--pos', this.pos.toFixed(1));
      // O chip "com BioBio" so aparece quando sobra largura pra ele inteiro.
      // Abaixo disso ele sairia cortado pelo clip-path e pareceria defeito.
      // 105px de chip + folga sobre 354px do mobile da ~67% de posicao maxima.
      var cabeChip = this.palco.offsetWidth
        ? (this.palco.offsetWidth * (100 - this.pos) / 100) >= 130
        : this.pos <= 67;
      if (cabeChip) this.setAttribute('data-ad-revelado', '');
      else this.removeAttribute('data-ad-revelado');
      this.handle.setAttribute('aria-valuenow', String(Math.round(this.pos)));
      this.handle.setAttribute('aria-valuetext', Math.round(this.pos) + '% do resultado à mostra');
    }

    posDoEvento(e) {
      var r = this.palco.getBoundingClientRect();
      return r.width ? ((e.clientX - r.left) / r.width) * 100 : this.pos;
    }

    aoPegar(e) {
      this.arrastando = true;
      try { this.handle.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      e.preventDefault();
    }
    aoMover(e) { if (this.arrastando) this.definirPos(this.posDoEvento(e)); }
    aoSoltar(e) {
      if (!this.arrastando) return;
      this.arrastando = false;
      try { this.handle.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
    }

    aoClicarPalco(e) {
      if (e.target === this.handle || this.handle.contains(e.target)) return;
      this.definirPos(this.posDoEvento(e));
      this.handle.focus();
    }

    aoTeclar(e) {
      var passo = e.shiftKey ? 10 : 1;
      var k = e.key;
      if (k === 'ArrowLeft' || k === 'ArrowDown') this.definirPos(this.pos - passo);
      else if (k === 'ArrowRight' || k === 'ArrowUp') this.definirPos(this.pos + passo);
      else if (k === 'Home') this.definirPos(0);
      else if (k === 'End') this.definirPos(100);
      else return;
      e.preventDefault();
    }
  }

  customElements.define('biobio-antes-depois', BiobioAntesDepois);
})();
